import { combineReducers } from 'redux';

import deviceReducer from './device';
import browserReducer from './browser';
import osReducer from './os';

const reducers = {
  device: deviceReducer,
  browser: browserReducer,
  os: osReducer,
};

export default combineReducers(reducers);
